import { Component, ViewChild, EventEmitter, Output, OnInit, AfterViewInit, Input } from '@angular/core';
declare const google: any;

@Component({
	selector: 'app-address-lookup',
	templateUrl: './address-lookup.component.html',
	styleUrls: ['./address-lookup.component.scss'],
})
export class AddressLookupComponent implements OnInit, AfterViewInit {

	@Input() adressType: string;
	@Input() country = 'us'; // fallback default
	@Input() include_canada = false;
	@Output() setAddress: EventEmitter<any> = new EventEmitter();
	@ViewChild('addresstext') addresstext: any;

	addressAutocompleteInput: string;
	queryWait: boolean;
	options: any;

	constructor() {}

	ngOnInit() {
		const isoCode = (this.country || 'us').toLowerCase().trim();
		const inputted = /^[a-z]{2}$/.test(isoCode) ? isoCode : 'us';
		let isos = [inputted];
		if(this.include_canada){
			isos = [...isos,'ca']
		}

		this.options = {
			componentRestrictions: { country: isos },
			fields: ['address_components', 'geometry', 'icon', 'name'],
			strictBounds: false,
		};
	}

	ngAfterViewInit() {
		this.getPlaceAutocomplete();
	}

	private getPlaceAutocomplete() {
		if (!this.addresstext?.nativeElement) {return;}

		const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement, this.options);

		google.maps.event.addListener(autocomplete, 'place_changed', () => {
			const place = autocomplete.getPlace();
			this.invokeEvent(place);
		});
	}

	private invokeEvent(place: object) {
		this.setAddress.emit(place);
	}
}